import React, { useState } from "react";

const ExpandableText = ({ text, maxLines = 3 }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: expanded ? "unset" : maxLines,
          WebkitBoxOrient: "vertical",
        }}
      >
        {text}
      </div>
      {text?.split(" ").length > 10 && (
        <span
          style={{ color: "#007bff", cursor: "pointer", fontSize: 12 }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show less" : "Show more"}
        </span>
      )}
    </div>
  );
};

export default ExpandableText;
